import { CalendarDateService, DateObject } from '../calendar-date-serivce/calendar-date-service';

export const isInPastByMonth = (date: DateObject) => {
  return date.isBefore(CalendarDateService.date(), 'month');
};
export const isExceedingByMonth = (date: DateObject, months: number) => {
  return date.isAfter(CalendarDateService.date().add(months, 'month'), 'month');
};

export const utcToLocalTime = (time: Date | string) => CalendarDateService.date.utc(time).local();

export const getLocalTime = (time: Date | string, format: string) =>
  utcToLocalTime(time).format(format);

export const LegacyDateTimeService = {
  getLocalTime,
  utcToLocalTime,
};
